const STORAGE_KEY = 'trackizy_notification_prefs';

const DEFAULTS = {
  toastDuration: 5,       // seconds: 3, 5, 8, 10
  maxToasts: 3,           // 1, 3, 5
  soundEnabled: false,
  browserPushEnabled: false,
};

export function getNotificationPrefs() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? { ...DEFAULTS, ...JSON.parse(stored) } : { ...DEFAULTS };
  } catch {
    return { ...DEFAULTS };
  }
}

export function setNotificationPrefs(prefs) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...getNotificationPrefs(), ...prefs }));
}

export function getDefaultPrefs() {
  return { ...DEFAULTS };
}
